<template>
  <div class="users">

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>

      </template>

      <template v-slot:actions>

        <div>
          <button v-if="hasAdminAccess"
            type="button"
            class="action-button hover:opacity-75"
            @click="addUser()"
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

    <table
      class="
      w-95p 
        mx-auto
        mb-2
        h-12
        pt-2
        align-text-bottom
        bg-white
        rounded
        text-left text-gray-400
      "
    >
    <thead class="bg-gray-100 w-full">
        <tr>
          <th class="w-3/12 pl-2">Name</th>
          <th class="w-3/12">Email</th>
          <th class="w-3/12">Type</th>
          <th class="w-1/12">Admin</th>
          <th class="w-1/12">Active</th>
          <th class="w-1/12"></th>
        </tr>
      </thead>
    </table>

    <div class="table-wrapper">
      <div v-if="errored" class="empty px-8 pt-6">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" v-else>
        <div
          style="width: 100%; text-align: center"
          class="spin-holder mt-4"
          v-if="loading"
        >
          <i class="spinner fa fa-spinner fa-spin"></i>
          <p>Loading Teachers</p>
        </div>

        <div v-else>
          <table
            v-if="componentLoaded"
            class="table-wrapper w-95p  bg-white mx-auto rounded shadow-sm"
          >
            <tbody>
              <tr v-for="user in filteredList" :key="user.identifier">
                <td class="w-3/12">{{ user.name }}</td>
                <td class="w-3/12">{{ user.email }}</td>
                
                <td class="w-3/12">{{ parseAccountType(user)}}</td>
                <td class="w-1/12">
                  <i
                    class="icon list"
                    v-bind:class="setActiveClass(user.is_admin)"
                  />
                </td>
                <td class=" w-1/12 pl-2" >
                  <i
                    class="icon list"
                    v-bind:class="setActiveClass(user.active)"
                  />
                </td>
                <td
                  
                  class="w-1/12 text-center text-xs cursor-pointer text-blue-400"
                >
                  <a v-if="hasAdminAccess" @click="editUser(user)">View</a>
                </td>
              </tr>
            </tbody>
          </table>

          <p class="m-5 mx-12" v-else>
            We could not find any data for your given selection.
          </p>
        </div>
      </div>
    </div>

    <ModalSlide :show="showTeacherEdit" @closeModal="closeUserEdit">
      <template v-slot:header-icon>
        <i class="fas fa-edit"></i>
      </template>
      <template v-slot:header-title>
        <div class="flex">
          <div> 
          Edit user details
          <div class="text-xs">Enter user information.</div>
          </div>
        </div>
      
      </template>
      <template v-slot:body>
        <TeacherEdit v-if="selectedTeacher != undefined" :teacher="selectedTeacher"  @teacher-edited="userEdited"></TeacherEdit>
      </template>
    </ModalSlide>

    <SchoolAdminModal v-if="showSchoolAdminModal" :teachers="activeList"  @close="showSchoolAdminModal = false"></SchoolAdminModal>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";
import { teacherTypeMixin } from "@/mixins/teacherTypeMixin.js";

const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const ModalSlide = () => import("@/components/ModalSlide.vue");
const TeacherEdit = () => import("@/components/admin/TheTeacherEdit.vue");
const SchoolAdminModal = () => import('@/components/admin/TheSchoolAdminModal.vue')

export default {
  name: "users",
  mixins: [teacherTypeMixin],
  props: {
    msg: { type: String, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    hasAdminAccess() {
      return this.currentUser.hasAdmin;
    },
    componentLoaded() {
      return this.filteredList.length > 0;
    },
    showMessage() {
      return this.msg != undefined && this.msg.length > 0;
    },
    filteredList() {
      var vm = this;
      var results = this.users.filter((item) => {
       return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
      return _.orderBy(results, ["name"]);
    },
    activeList() {
      return this.users.filter((item) => {
       return item.active === 1;
      });
    }
  },
  data() {
    return {
      search: "",
      selectAll: false,
      users: [],
      loading: true,
      errored: false,
      selectedTeacher: undefined,
      showTeacherEdit: false,
      showSchoolAdminModal: false
    };
  },
  created() {
    this.checkAccess();
  },
  mounted() {},

  methods: {
    checkAccess() {
      this.fetchData()
    },
    fetchData() {
      SchoolService.getAll("users")
        .then((response) => (this.parseUserData(response.data.data)))
        .catch((err) => {
          console.log("users " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    parseUserData(data) {
      this.users = data

      let vm = this
      let found = vm.users.find((u) => {
        return u.is_admin === true
      })

      if (!found) {
        this.showSchoolAdminModal = true
      }
      
    },
    setActiveClass(active) {
      if (active == 1) {
        return "fas fa-check-circle true";
      } else {
        return "fas fa-times-circle text-gray-300";
      }
    },
    editUser(user) {
      this.selectedTeacher = user
      this.showTeacherEdit = true
      this.teacherInEdit = true
    },
    addUser() {
      this.selectedTeacher = {}
      this.showTeacherEdit = true
      this.teacherInEdit = true
    },
    closeUserEdit(time = 500) {
      this.showTeacherEdit = false
      this.fetchData()

      let vm = this;
      clearTimeout(vm.timeout);
        vm.timeout = setTimeout(() => {
          vm.selectedTeacher = undefined
        }, time);
     
    },
    userEdited() {
      this.closeUserEdit()
    },
    parseAccountType(user) {
      return this.teacherType(user.usertype_id).name
    },
    setSearchValue(value, time = 500) {
      this.search = value;
    },
  },
  components: {
    ModalSlide,
    TeacherEdit,
    FilterBar,
    SchoolAdminModal
  },
};
</script>

<style>
i.icon {
  font-size: 18px;
  padding-left: 4px;
  padding-top: 4px;
}
</style>
